import React, { useCallback, useEffect, useMemo, useState } from "react";
import useTranslation from "../util/useTranslate";
import { Button, Container, Row, Col } from "react-bootstrap";
import {
  ArrowRightCircle,
  ArrowLeftCircle,
  CheckCircleFill,
  Pencil,
} from "react-bootstrap-icons";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import PlayerIcon from "../Components/PlayerIcon";
import ChangeTeamNameModal from "../Components/ChangeTeamNameModal";
import { createGame } from "util/supabase";
import { useSupabasePostgresSubscription } from "util/useSupabsePostgresSubscription";

const TEAMS = [1, null, 2];

const GameSettings = () => {
  const { gameId } = useParams();
  const translate = useTranslation();
  const navigate = useNavigate();
  const [showChangeTeamNameModal, setShowChangeTeamNameModal] = useState(false);

  const {
    currentPlayerState,
    getCurrentGameSettings,
    updateState,
    broadcastEvent,
  } = useOutletContext();

  const gameSettings = getCurrentGameSettings(gameId);

  useSupabasePostgresSubscription({
    events: [
      { event: 'INSERT',
      schema: 'public',
      table: 'sessions',
      filter: `id=eq.${gameId}`, callback: (payload) => {
        navigate(`/game/${gameId}`);
      } },
    ],
  });

  const handleJoinTeam = (direction) => {
    let teamIndex = TEAMS.findIndex((item) => item === currentPlayer.team);
    updateState({ team: TEAMS[teamIndex + direction] });
  };

  const handlePlayerReadyToggle = () => {
    updateState({ ready: true });
  };

  const { redTeam, neutral, blueTeam } = useMemo(
    () => ({
      redTeam: gameSettings?.players?.filter((item) => item.team === 1),
      neutral: gameSettings?.players?.filter((item) => item.team === null),
      blueTeam: gameSettings?.players?.filter((item) => item.team === 2),
    }),
    [gameSettings?.players]
  );

  const currentPlayer = useMemo(
    () =>
      gameSettings?.players?.find(
        (item) => item.id === currentPlayerState?.subscriptionId
      ),
    [gameSettings?.players, currentPlayerState?.subscriptionId]
  );

  const getPlayerIndex = useCallback(
    (id) => gameSettings?.players?.findIndex((item) => item.id === id),
    [gameSettings?.players]
  );

  useEffect(() => {
    if (
      gameSettings?.players?.every((player) => player.ready) &&
      gameSettings?.players?.length === 4 &&
      currentPlayer?.isHost
    ) {
      createGame(gameSettings, gameId);
    }
  }, [gameSettings, currentPlayer, gameId]);

  console.log(currentPlayerState);

  useEffect(() => {
    if (!!currentPlayerState?.sessionId && !gameSettings) {
      navigate("/lobby");
    }
  }, [currentPlayerState, gameSettings, navigate]);

  useEffect(() => {
    if (!currentPlayerState || gameSettings?.players.length === 4) {
      navigate("/lobby");
    } else {
      updateState({ sessionId: gameId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!gameSettings || !currentPlayer) return null;

  return (
    <>
      <Container className="mt-4">
        <Row className="gap-3">
          <Col
            className="d-flex justify-content-center align-items-center"
            style={{ border: "1px solid red", height: 30, borderRadius: 10 }}
          >
            <h4>{gameSettings.teamNames[0]}</h4>
          </Col>
          <Col className="d-flex justify-content-center align-items-center">
            <h4>{translate("team")}</h4>
          </Col>
          <Col
            className="d-flex justify-content-center align-items-center"
            style={{ border: "1px solid blue", height: 30, borderRadius: 10 }}
          >
            <h4>{gameSettings.teamNames[1]}</h4>
          </Col>
        </Row>
        <Row className="gap-3">
          <Col
            style={{
              width: "30vw",
              minHeight: 280,
              height: "40vh",
              borderRadius: "15px",
              background: "url(/backgrounds/redCard.png)",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top center",
            }}
          >
            {redTeam.map((item) => (
              <Row className="mt-4" key={item.id}>
                <Col
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    maxWidth: "27vw",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    background: "white",
                    border: "1px solid black",
                    height: 30,
                    borderRadius: 10,
                    margin: "0 10px",
                  }}
                >
                  <h4>{item.name}</h4>{" "}
                  <PlayerIcon
                    playerIndex={getPlayerIndex(item.id)}
                    active={item.ready}
                  />
                </Col>
              </Row>
            ))}
          </Col>
          <Col style={{ minHeight: 280, width: "30vw" }}>
            {neutral.map((item) => (
              <Row className="mt-4" key={item.id}>
                <Col
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    maxWidth: "27vw",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    background: "white",
                    border: "1px solid black",
                    height: 30,
                    borderRadius: 10,
                    margin: "0 10px",
                  }}
                >
                  <h4>{item.name}</h4>{" "}
                  <PlayerIcon
                    playerIndex={getPlayerIndex(item.id)}
                    active={item.ready}
                  />
                </Col>
              </Row>
            ))}
          </Col>
          <Col
            style={{
              width: "30vw",
              minHeight: 280,
              height: "40vh",
              borderRadius: "15px",
              background: "url(/backgrounds/blueCard.png)",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top center",
            }}
          >
            {blueTeam.map((item) => (
              <Row className="mt-4" key={item.id}>
                <Col
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    maxWidth: "27vw",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    background: "white",
                    border: "1px solid black",
                    height: 30,
                    borderRadius: 10,
                    margin: "0 10px",
                  }}
                >
                  <h4>{item.name}</h4>{" "}
                  <PlayerIcon
                    playerIndex={getPlayerIndex(item.id)}
                    active={item.ready}
                  />
                </Col>
              </Row>
            ))}
          </Col>
        </Row>

        <Container className="p-3 mt-2">
          <Row className="gap-4">
            <Col className="d-flex gap-4 flex-row align-items-center justify-content-center">
              <Button
                size="lg"
                variant="primary"
                disabled={
                  currentPlayer.team === 1 ||
                  (redTeam.length === 2 && currentPlayer.team === null) ||
                  currentPlayer.ready
                }
                onClick={() => handleJoinTeam(-1)}
              >
                <ArrowLeftCircle />
              </Button>
              <Button
                size="lg"
                disabled={currentPlayer.team === null}
                variant={currentPlayer.ready ? "success" : "primary"}
                onClick={handlePlayerReadyToggle}
              >
                {translate("ready")} <CheckCircleFill />
              </Button>
              <Button
                size="lg"
                disabled={
                  currentPlayer.team === 2 ||
                  (blueTeam.length === 2 && currentPlayer.team === null) ||
                  currentPlayer.ready
                }
                variant="primary"
                onClick={() => handleJoinTeam(1)}
              >
                <ArrowRightCircle />
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col className="d-flex justify-content-center">
              <Button
                size="lg"
                disabled={
                  !currentPlayer.team ||
                  ![blueTeam[0]?.id, redTeam[0]?.id].includes(
                    currentPlayer.id
                  ) ||
                  currentPlayer.ready
                }
                variant="primary"
                onClick={() => setShowChangeTeamNameModal(true)}
              >
                {translate("changeTeamName")} <Pencil />
              </Button>
            </Col>
          </Row>
        </Container>
      </Container>
      <ChangeTeamNameModal
        show={showChangeTeamNameModal}
        currentName={gameSettings.teamNames[currentPlayer.team - 1]}
        onHide={() => setShowChangeTeamNameModal(false)}
        onSubmit={(name) =>
          broadcastEvent("changeTeamName", {
            name,
            index: currentPlayer.team - 1,
            sessionId: gameId,
          })
        }
      />
    </>
  );
};

export default GameSettings;
